import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgWindowsLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m3.5 6.03 8.606-1.243V13.5H3.5V6.03Zm0 15.94 8.606 1.242V14.61H3.5v7.361Zm9.553 1.375L24.5 25V14.609H13.053v8.736Zm0-18.69v8.844H24.5V3L13.053 4.655Z" />
  </svg>
);
export default SvgWindowsLogo;
